export function splitErrorMessageForToast(message: string | null | undefined): {
	title: string;
	description?: string;
} {
	const normalizedMessage = message?.trim();

	if (!normalizedMessage) {
		return { title: "操作失败，请稍后再试" };
	}

	const [title, ...rest] = normalizedMessage.split("\n").filter(Boolean);
	const description = rest.length > 0 ? rest.join("\n") : undefined;

	return { title, description };
}
